import React from "react";

import { useAuth } from "../../context/AuthContext";
import { openLinkInBrowser } from "../../utils/helpers";

const SubscriptionRequiredScreen: React.FC = () => {
  const { clearSubscriptionRequired, trialInfo } = useAuth();

  return (
    <div className="min-h-screen w-full bg-[#1F1F1F] flex items-center justify-center px-6 py-10 text-[#E0E0E0]">
      <div className="w-full max-w-lg bg-[#2A2A2A]  rounded-xl shadow-lg p-8 space-y-6 text-center">
        <h1 className="text-2xl font-semibold">Subscription Required</h1>
        <p className="text-sm text-[#B0B0B0]">
          Your free trial has ended. To keep using salesforce connector, please
          activate your subscription. Once your subscription is active, you can
          sign back in and pick up where you left off.
        </p>
        {trialInfo?.expiresAt && (
          <p className="text-xs text-[#8C8C8C]">
            Trial ended on{" "}
            {new Date(trialInfo.expiresAt).toLocaleString(undefined, {
              dateStyle: "medium",
              timeStyle: "short",
            })}
          </p>
        )}
        <div className="space-y-2">
          <button
            type="button"
            className="w-full bg-[#3F3F3F] hover:bg-[#505050] text-white font-semibold py-2 rounded-md transition-colors"
            onClick={() => {
              openLinkInBrowser(
                process.env.REACT_APP_LEMON_SQUEEZY_SUBSCRIPTION_URL
              );
            }}
          >
            Buy Subscription
          </button>
          <button
            type="button"
            onClick={clearSubscriptionRequired}
            className="w-full bg-[#3F3F3F] hover:bg-[#505050] text-[#E0E0E0] font-semibold py-2 rounded-md transition-colors"
          >
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRequiredScreen;
